import { ClipboardList, Fish, LayoutDashboard, Ship, ShoppingBasket, Tag } from "lucide-react";

export const seed = {
  catches: [
    { id: 1, date: "18 Jun 2024", species: "Tongkol", vessel: "KM Sinar Laut", weight: 486, value: 14580000, zone: "WPP 573" },
    { id: 2, date: "18 Jun 2024", species: "Cakalang", vessel: "KM Barokah", weight: 312, value: 12480000, zone: "WPP 573" },
    { id: 3, date: "17 Jun 2024", species: "Tuna Sirip Kuning", vessel: "KM Mina Jaya", weight: 168, value: 16800000, zone: "WPP 573" },
    { id: 4, date: "17 Jun 2024", species: "Layur", vessel: "KM Sumber Rejeki", weight: 236, value: 8260000, zone: "Selatan Jawa" }
  ],
  vessels: [
    { id: 1, name: "KM Sinar Laut", owner: "Asep Suryana", gt: "18 GT", gear: "Pancing Ulur", status: "Aktif" },
    { id: 2, name: "KM Barokah", owner: "Deni Kurnia", gt: "12 GT", gear: "Jaring Insang", status: "Aktif" },
    { id: 3, name: "KM Mina Jaya", owner: "Ujang Suherman", gt: "24 GT", gear: "Rawai Tuna", status: "Aktif" },
    { id: 4, name: "KM Sumber Rejeki", owner: "Yayan Mulyana", gt: "8 GT", gear: "Pancing Ulur", status: "Perlu Perpanjang" }
  ],
  auctions: [
    { id: 1, species: "Tongkol", lot: "T-240618-01", weight: "486 kg", price: 30000, buyer: "CV Laut Jaya", status: "Selesai" },
    { id: 2, species: "Cakalang", lot: "C-240618-02", weight: "312 kg", price: 40000, buyer: "PT Segara Makmur", status: "Berlangsung" },
    { id: 3, species: "Tuna Sirip Kuning", lot: "T-240617-05", weight: "168 kg", price: 100000, buyer: "UD Mina Sejahtera", status: "Selesai" }
  ],
  prices: [
    { species: "Tuna Sirip Kuning", price: 100000, change: 8.4, tone: "up" },
    { species: "Cakalang", price: 40000, change: 3.1, tone: "up" },
    { species: "Tongkol", price: 30000, change: -2.2, tone: "down" },
    { species: "Layur", price: 35000, change: 1.6, tone: "up" }
  ]
};

export const nav = [
  ["dashboard", "Dashboard", LayoutDashboard], ["catches", "Pendataan Tangkapan", Fish],
  ["vessels", "Kapal & Nelayan", Ship], ["auctions", "Lelang TPI", ShoppingBasket],
  ["prices", "Harga Market", Tag], ["reports", "Laporan", ClipboardList]
];

export const RETRIBUSI = 0.02;
export const number = (n) => new Intl.NumberFormat("id-ID").format(n);
export const money = (n) => `Rp ${number(Math.round(n))}`;
export const loadData = () => { try { return JSON.parse(localStorage.getItem("sipikan-data")) || seed; } catch { return seed; } };
